<template>
  <div>
    <Spinner v-if="!isInitialized" />
    <router-view
      v-if="isInitialized"
      :loading="loading"
      :contacts="contacts"
      :tags="tags"
      :meta="meta"
      @add-tag="onAddTag"
      @remove-tag="onDeleteTag"
      @update-contact="onUpdateContact"
      @filter="onFilter"
      @contacts:pagination="onPagination"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Spinner from '@/components/shared/Spinner'

export default {
  name: 'ContactsHome',
  components: {
    Spinner,
  },
  data() {
    return {
      loading: true,
      isInitialized: false,
    }
  },
  computed: {
    ...mapGetters('contacts', { contacts: 'getArray', meta: 'getMeta', tags: 'tags' }),
  },
  methods: {
    ...mapMutations('contacts', { addContactsFilter: 'ADD_FILTER', setPageOrder: 'SET_SORT' }),
    ...mapActions('contacts', {
      getContacts: 'readCollection',
      readContactTagCollection: 'readContactTagCollection',
      addTagToContact: 'addTagToContact',
      removeTagFromContact: 'removeTagFromContact',
      updateContact: 'update',
    }),
    onFilter() {
      this.addContactsFilter({ key: 'pageNumber', value: 1 })
      this.fetch()
    },
    async fetch() {
      this.loading = true
      await this.getContacts()
      this.loading = false
    },
    async onAddTag(tag) {
      this.dispatchLoadingEvent(true)
      await this.addTagToContact(tag)
      this.dispatchLoadingEvent(false)
    },
    async onDeleteTag(tag) {
      this.dispatchLoadingEvent(true)
      await this.removeTagFromContact(tag)
      this.dispatchLoadingEvent(false)
    },
    async onUpdateContact(contact) {
      this.loading = true
      await this.updateContact(contact)
      this.loading = false
    },
    async onPagination(value) {
      this.addContactsFilter({ key: 'pageNumber', value })
      this.fetch()
    },
    dispatchLoadingEvent(isLoading) {
      const state = isLoading ? 'tags-loading-start' : 'tags-loading-stop'
      const event = new CustomEvent('tags-loading', {
        detail: {
          state,
        },
      })
      document.dispatchEvent(event)
    },
  },
  async created() {
    this.addContactsFilter({ key: 'pageSize', value: 30 })
    this.setPageOrder({ key: 'created_at', value: 'DESC' })
    await this.readContactTagCollection()
    await this.fetch()
    this.isInitialized = true
  },
}
</script>

<style lang="less" scoped></style>
